module.exports = {"global":{"search":"Search...","first":"First","previous":"Previous","next":"Next","last":"Last"},"ticket":{"tickets_list":"Tickets","create_ticket":"Create ticket","added_ticket":"A new ticket has been added","answer_ticket":"Answer ticket","table":{"for":"FOR","title":"TITLE"}},"pack":{"budgeted_module":"Budgeted module","alternative_modules":"Alternative modules"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = 784
// module chunks = 43